import { useEffect } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux/es/hooks/useSelector';
import installationService from '../services/installation';
import { shallowEqual } from 'react-redux';

export const PathLogout = ({ children }) => {
  const { user } = useSelector((state) => state.auth, shallowEqual);
  const menuActive = useSelector((list) => list.menu.activeMenu, shallowEqual);
  const navigate = useNavigate();
  const location = useLocation();

  // useEffect(() => {
  //   installationService
  //     .checkInitFile()
  //     .then(() => console.log('file found'))
  //     .catch((data) => {
  //       //commented this to disable project setup with purchase id
  //       navigate('/welcome');
  //     });
  // }, []);

  if (user) {
    // If on login/welcome pages, redirect away (these pages should not be accessible when logged in)
    if (
      location.pathname === '/login' ||
      location.pathname === '/login/otp' ||
      location.pathname === '/welcome' ||
      location.pathname === '/installation'
    ) {
      // If menuActive is default dashboard, redirect to dashboard
      // Otherwise, preserve current location by not redirecting (let TabMenu handle it)
      const isDefaultDashboard =
        menuActive?.url === 'dashboard' && menuActive?.id === 1;
      if (isDefaultDashboard || !menuActive) {
        return <Navigate to='/dashboard' replace />;
      }
      return <Navigate to={`/${menuActive.url}`} replace />;
    }

    // For all other pages, if menuActive is default dashboard, preserve current location
    // This handles the refresh case where menu state resets to default
    const isDefaultDashboard =
      menuActive?.url === 'dashboard' && menuActive?.id === 1;
    if (isDefaultDashboard) {
      // Stay on current page - TabMenu will sync the menu state from URL
      return children;
    }

    // If menuActive exists and is not default, and we're not on the correct page, redirect
    if (
      menuActive &&
      location.pathname !== `/${menuActive.url}` &&
      !location.pathname.startsWith(`/${menuActive.url}/`)
    ) {
      return <Navigate to={`/${menuActive.url}`} replace />;
    }
  }

  return children;
};
